
export const ajaxUrl = 'https://winline.by/api/init/v2';

export const staticLink = 'https://winlineby.onelink.me/mg4S';
export const staticQrCodeLink = 'https://winlineby.onelink.me/mg4S';

export const documentsContainer = '.js-dynamic-list-documents';
export const gamersContainer = '.js-dynamic-list-gamers'; 


// WEBPACK FOOTER //
// ./_layout/js/constants.js